var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3V12.5C14 12.9125 13.8531 13.2656 13.5594 13.5594C13.2656 13.8531 12.9125 14 12.5 14H1.5C1.0875 14 0.734375 13.8531 0.440625 13.5594C0.146875 13.2656 0 12.9125 0 12.5V1.5C0 1.0875 0.146875 0.734376 0.440625 0.440626C0.734375 0.146876 1.0875 0 1.5 0H11L14 3ZM12.5 3.625L10.375 1.5H1.5V12.5H12.5V3.625ZM7 11.75C7.625 11.75 8.15625 11.5312 8.59375 11.0938C9.03125 10.6562 9.25 10.125 9.25 9.5C9.25 8.875 9.03125 8.34375 8.59375 7.90625C8.15625 7.46875 7.625 7.25 7 7.25C6.375 7.25 5.84375 7.46875 5.40625 7.90625C4.96875 8.34375 4.75 8.875 4.75 9.5C4.75 10.125 4.96875 10.6562 5.40625 11.0938C5.84375 11.5312 6.375 11.75 7 11.75ZM2.5 5.5H9.5V2.5H2.5V5.5ZM1.5 3.89583V12.5V1.5V3.89583Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveWhite);
export default __webpack_public_path__ + "static/media/save-white.65c24bbfc1ae3f653c3c2240d9c0d37a.svg";
export { ForwardRef as ReactComponent };